import Plugin from '../core/Plugin';

/**
 * IconLibraryPlugin for QuillKit
 * Adds a toolbar button to open the ConvertBlock icon picker and insert icons.
 */
class IconLibraryPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'IconLibraryPlugin';
  }

  init() {
    super.init();
    // Optionally, setup anything needed on init
  }

  getToolbarButtons() {
    return [
      {
        name: 'icon-library',
        buttons: [
          {
            command: 'icon-library',
            label: '<i class="fa-solid fa-icons"></i>',
            title: 'Insert Icon',
            onClick: () => this.openIconPicker(),
          },
        ],
      },
    ];
  }

  openIconPicker() {
    // Use the editor's icon modal instead of external library
    this.editor.showIconModal();
  }
}

export default IconLibraryPlugin;
